const alignTop = (locateRect, targetSize) => {
    const { height: locateHeight } = locateRect;
    const { height: targetHeight } = targetSize;
    return {
        top: -targetHeight,
        bottom: locateHeight,
    };
};
const alignBottom = (locateRect, targetSize) => {
    const { height: locateHeight } = locateRect;
    const { height: targetHeight } = targetSize;
    return {
        top: locateHeight,
        bottom: locateHeight + targetHeight,
    };
};
const alignLeft = (_, targetSize) => {
    const { width: targetWidth } = targetSize;
    return {
        left: -targetWidth,
        right: 0,
    };
};
const alignRight = (locateRect, targetSize) => {
    const { width: locateWidth } = locateRect;
    const { width: targetWidth } = targetSize;
    return {
        left: locateWidth,
        right: targetWidth,
    };
};
const alignXBegin = (_, targetSize) => {
    const { width: targetWidth } = targetSize;
    return {
        left: 0,
        right: targetWidth,
    };
};
const alignXCenter = (locateRect, targetSize) => {
    const { width: locateWidth } = locateRect;
    const { width: targetWidth } = targetSize;
    const xCenterLeft = (locateWidth - targetWidth) / 2;
    return {
        left: xCenterLeft,
        right: xCenterLeft + targetWidth,
    };
};
const alignXEnd = (locateRect, targetSize) => {
    const { width: locateWidth } = locateRect;
    const { width: targetWidth } = targetSize;
    return {
        left: locateWidth - targetWidth,
        right: 0,
    };
};
const alignYBegin = (_, targetSize) => {
    const { height: targetHieght } = targetSize;
    return {
        top: 0,
        bottom: targetHieght,
    };
};
const alignYCenter = (locateRect, targetSize) => {
    const { height: locateHeight } = locateRect;
    const { height: targetHieght } = targetSize;
    const yCenterTop = (locateHeight - targetHieght) / 2;
    return {
        top: yCenterTop,
        bottom: yCenterTop + targetHieght,
    };
};
const alignYEnd = (locateRect, targetSize) => {
    const { height: locateHeight } = locateRect;
    const { height: targetHieght } = targetSize;
    return {
        top: locateHeight - targetHieght,
        bottom: 0,
    };
};
const alignTopXBegin = (locateRect, targetSize) => ({
    ...targetSize,
    ...alignTop(locateRect, targetSize),
    ...alignXBegin(locateRect, targetSize),
});
const alignTopXCenter = (locateRect, targetSize) => ({
    ...targetSize,
    ...alignTop(locateRect, targetSize),
    ...alignXCenter(locateRect, targetSize),
});
const alignTopXEnd = (locateRect, targetSize) => ({
    ...targetSize,
    ...alignTop(locateRect, targetSize),
    ...alignXEnd(locateRect, targetSize),
});
const alignBottomXBegin = (locateRect, targetSize) => ({
    ...targetSize,
    ...alignBottom(locateRect, targetSize),
    ...alignXBegin(locateRect, targetSize),
});
const alignBottomXCenter = (locateRect, targetSize) => ({
    ...targetSize,
    ...alignBottom(locateRect, targetSize),
    ...alignXCenter(locateRect, targetSize),
});
const alignBottomXEnd = (locateRect, targetSize) => ({
    ...targetSize,
    ...alignBottom(locateRect, targetSize),
    ...alignXEnd(locateRect, targetSize),
});
const alignLeftYBegin = (locateRect, targetSize) => ({
    ...targetSize,
    ...alignLeft(locateRect, targetSize),
    ...alignYBegin(locateRect, targetSize),
});
const alignLeftYCenter = (locateRect, targetSize) => ({
    ...targetSize,
    ...alignLeft(locateRect, targetSize),
    ...alignYCenter(locateRect, targetSize),
});
const alignLeftYEnd = (locateRect, targetSize) => ({
    ...targetSize,
    ...alignLeft(locateRect, targetSize),
    ...alignYEnd(locateRect, targetSize),
});
const alignRightYBegin = (locateRect, targetSize) => ({
    ...targetSize,
    ...alignRight(locateRect, targetSize),
    ...alignYBegin(locateRect, targetSize),
});
const alignRightYCenter = (locateRect, targetSize) => ({
    ...targetSize,
    ...alignRight(locateRect, targetSize),
    ...alignYCenter(locateRect, targetSize),
});
const alignRightYEnd = (locateRect, targetSize) => ({
    ...targetSize,
    ...alignRight(locateRect, targetSize),
    ...alignYEnd(locateRect, targetSize),
});

export { alignBottom, alignBottomXBegin, alignBottomXCenter, alignBottomXEnd, alignLeft, alignLeftYBegin, alignLeftYCenter, alignLeftYEnd, alignRight, alignRightYBegin, alignRightYCenter, alignRightYEnd, alignTop, alignTopXBegin, alignTopXCenter, alignTopXEnd, alignXBegin, alignXCenter, alignXEnd, alignYBegin, alignYCenter, alignYEnd };
//# sourceMappingURL=index.js.map
